import { IConsultantProfile } from "../types-ensure";
import { ConsultantProfileActiveType } from "../types/ConsultantProfileActiveType";
import { isActive } from "./isActive";
import { isBlocked } from "./isBlocked";

export const getConsultantProfileActiveType = (profile: IConsultantProfile): ConsultantProfileActiveType => {
  if (isActive(profile)) {
    return "ACTIVE";
  } else if (isBlocked(profile)) {
    return "BLOCKED";
  } else {
    return "PENDING";
  }
};
